<template>
  <div>
    <button
      v-if="canUserEdit"
      v-b-modal.editRuleGroup
      v-b-tooltip.hover
      class="btn btn-primary"
      placement="bottom"
      style="padding-bottom: 4px"
      title="Regel-Konfiguration bearbeiten"
      type="button"
    >
      <i
        class="fas fa-cog"
        style="font-size: 18px"
      />
    </button>
    <b-modal
      id="editRuleGroup"
      ref="editRuleGroup"
      hide-footer
      no-fade
      size="xl"
      title="Regel-Konfiguration bearbeiten"
    >
      <u-error-handling
        v-if="errorObject"
        :error-object="errorObject"
        :property-mapping="errorPropertyMappings"
      />
      <u-loader v-if="isLoading" />
      <div
        v-else
        class="d-block mb-4"
      >
        <div class="row">
          <div class="col-2">
            <label class="font-weight-bold mt-3">Name</label>
          </div>
          <div class="col-10">
            <v-text-field
              v-model="currentRuleConfig.name"
              label="Name"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-2">
            <label class="font-weight-bold mt-3">Regel-Eigenschaften</label>
          </div>
          <div class="col-10 mt-3">
            <div
              v-for="(property, index) in currentRuleConfig.configEntries"
              :key="index"
              class="configEntryLine"
            >
              <div class="row ml-0 mt-1">
                <div class="customCol">
                  <div
                    v-b-tooltip.hover
                    :class="{ selected: property.criteriaStructureId }"
                    class="addRuleGroupButton float-left"
                    placement="bottom"
                    title="Strukturelement"
                    @click="typeChanged(index, 0)"
                  >
                    <i class="fas fa-keyboard" />
                  </div>
                  <div
                    v-b-tooltip.hover
                    :class="{ selected: property.criteriaGroupId }"
                    class="addRuleGroupButton float-left"
                    placement="bottom"
                    title="Eingabegruppierung"
                    @click="typeChanged(index, 1)"
                  >
                    <i class="fas fa-object-ungroup" />
                  </div>
                  <div
                    v-b-tooltip.hover
                    :class="{ selected: property.variableId }"
                    class="addRuleGroupButton float-left"
                    placement="bottom"
                    title="Variable"
                    @click="typeChanged(index, 2)"
                  >
                    <i class="fas fa-cubes" />
                  </div>
                </div>
                <div class="customCol80 ml-3">
                  <div v-if="property.criteriaStructureId">
                    <v-select
                      v-model="property.criteriaStructureId"
                      :items="
                        $store.state.mindestLohnKonfiguration.StructureFlat
                      "
                      item-text="name"
                      item-value="id"
                    />
                  </div>
                  <div v-if="property.criteriaGroupId">
                    <v-select
                      v-model="property.criteriaGroupId"
                      :items="$store.state.mindestLohnKonfiguration.Groupings"
                      item-text="name"
                      item-value="id"
                    />
                  </div>
                  <div v-if="property.variableId">
                    <v-select
                      v-model="property.variableId"
                      :items="$store.state.mindestLohnKonfiguration.Variables"
                      item-text="name"
                      item-value="id"
                    />
                  </div>
                </div>
                <div class="col-1">
                  <button
                    v-b-modal.confirmDeleteProperty
                    v-b-tooltip.hover
                    class="btn btn-danger"
                    placement="bottom"
                    title="Eigenschaft löschen"
                    type="button"
                    @click="indexToDelete = index"
                  >
                    <i class="fas fa-trash-alt" />
                  </button>
                </div>
              </div>
            </div>
            <div class="row ml-1">
              <div class="customCol11" />
              <div class="customCol80" />
              <div class="col-1">
                <button
                  v-b-tooltip.hover
                  class="btn btn-success mt-1"
                  placement="bottom"
                  title="Eigenschaft hinzufügen"
                  type="button"
                  @click="addNewProperty()"
                >
                  <i class="fas fa-plus" />
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <b-button
        v-if="!isLoading"
        variant="success"
        @click="saveRulesGroupConfiguration()"
      >
        Speichern
      </b-button>
      <b-button
        v-if="!isLoading"
        class="ml-2"
        variant="danger"
        @click="hideModal('editRuleGroup')"
      >
        Abbrechen
      </b-button>
    </b-modal>
    <b-modal
      id="confirmDeleteProperty"
      ref="confirmDeleteProperty"
      class="mt-4"
      hide-footer
      no-fade
      title="Eigenschaft Löschen"
    >
      <div class="d-block mb-4">
        Sind Sie sicher, dass sie diese Eigenschaft löschen möchten?
      </div>
      <b-button
        variant="success"
        @click="deleteProperty()"
      >
        Ok
      </b-button>
      <b-button
        class="ml-2"
        variant="danger"
        @click="hideModal('confirmDeleteProperty', true)"
      >
        Abbrechen
      </b-button>
    </b-modal>
  </div>
</template>

<script>
import {
  GetSingleRulesGroupConfiguration,
  SaveSingleRulesGroupConfiguration,
} from "@/services/minimum.wage.services/rules.minimum.wages.js";
import { MinimumWageMixin } from "@/components/minimum.wage/mixins/MinimumWageMixin";

export default {
  mixins: [MinimumWageMixin],
  props: {
    rulesgroupConfiguration: {
      type: Object,
      required: true,
    },
    contractId: {
      type: String,
      default: "",
    },
    versionId: {
      type: Number,
      default: 0,
    },
    editionId: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      currentRuleConfig: null,
      isLoading: false,
      errorObject: null,
      indexToDelete: -1,
      errorPropertyMappings: [],
    };
  },
  created() {
    var sortedEntries = JSON.parse(
      JSON.stringify(this.rulesgroupConfiguration.configEntries),
    );
    this.currentRuleConfig = JSON.parse(
      JSON.stringify(this.rulesgroupConfiguration),
    );
    this.currentRuleConfig.configEntries = [];
    sortedEntries.map((entry) => {
      if (entry.criteriaStructureId)
        this.currentRuleConfig.configEntries.push(
          JSON.parse(JSON.stringify(entry)),
        );
    });
    sortedEntries.map((entry) => {
      if (entry.criteriaGroupId)
        this.currentRuleConfig.configEntries.push(
          JSON.parse(JSON.stringify(entry)),
        );
    });
    sortedEntries.map((entry) => {
      if (entry.variableId)
        this.currentRuleConfig.configEntries.push(
          JSON.parse(JSON.stringify(entry)),
        );
    });
  },
  methods: {
    addNewProperty() {
      this.currentRuleConfig.configEntries.push({
        id: 0,
        ruleConfigurationId: null,
        ruleGroupEntryId: null,
        criteriaStructureId: -1,
        criteriaStructure: null,
        criteriaGroupId: null,
        criteriaGroup: null,
        variableId: null,
        variable: null,
        order: 0,
      });
    },
    deleteProperty() {
      this.currentRuleConfig.configEntries.splice(this.indexToDelete, 1);
      this.hideModal("confirmDeleteProperty", true);
    },
    createErrorPropertyMappings() {
      var mapping = {};

      return mapping;
    },
    typeChanged(index, newType) {
      this.currentRuleConfig.configEntries[index].criteriaStructureId = null;
      this.currentRuleConfig.configEntries[index].criteriaGroupId = null;
      this.currentRuleConfig.configEntries[index].variableId = null;

      switch (newType) {
        case 0:
          this.currentRuleConfig.configEntries[index].criteriaStructureId = -1;
          break;

        case 1:
          this.currentRuleConfig.configEntries[index].criteriaGroupId = -1;
          break;

        case 2:
          this.currentRuleConfig.configEntries[index].variableId = -1;
          break;
      }
    },
    hideModal(modalId, doNotUpdateParent) {
      this.$refs[modalId].hide();
      if (!doNotUpdateParent) {
        this.$emit("updated");
      }
    },
    saveRulesGroupConfiguration() {
      this.errorObject = null;
      this.isLoading = true;
      this.errorPropertyMappings = this.createErrorPropertyMappings();

      this.rulesgroupConfiguration.configEntries = JSON.parse(
        JSON.stringify(this.currentRuleConfig.configEntries),
      );

      SaveSingleRulesGroupConfiguration(
        this.contractId,
        this.versionId,
        this.editionId,
        this.currentRuleConfig.id,
        this.currentRuleConfig,
        () => {
          this.hideModal("editRuleGroup");
          this.getSingleRulesGroupConfiguration();
        },
        (error) => {
          this.errorObject = error;
          this.isLoading = false;
        },
      );
    },
    getSingleRulesGroupConfiguration() {
      this.errorObject = null;
      this.isLoading = true;

      GetSingleRulesGroupConfiguration(
        this.contractId,
        this.versionId,
        this.editionId,
        this.rulesgroupConfiguration.id,
        (success) => {
          this.rulesgroupConfiguration = JSON.parse(JSON.stringify(success));
          this.$emit("input", JSON.parse(JSON.stringify(success)));
          this.$emit("updated");
          this.isLoading = false;
        },
        (error) => {
          this.errorObject = error;
          this.isLoading = false;
        },
      );
    },
  },
};
</script>

<style>
#confirmDeleteProperty___BV_modal_content_ {
  margin-top: 40px;
}

.configEntryLine .v-text-field {
  padding: 0px;
  margin: 0px;
}
</style>

<style scoped>
.customCol11 {
  -ms-flex: 0 0 11%;
  -webkit-box-flex: 0;
  flex: 0 0 11%;
  max-width: 11%;
}

.customCol80 {
  -ms-flex: 0 0 80%;
  -webkit-box-flex: 0;
  flex: 0 0 80%;
  max-width: 80%;
}

.typeSymbolWrapper {
  border: 1px solid black;
}

.addRuleGroupButton {
  height: 30px;
  width: 30px;
  padding: 2px 6px;
  background-color: #dfdfdf;
  border: 2px solid #dfdfdf;
  cursor: pointer;
}

.addRuleGroupButton:hover {
  background-color: #c7c7c7;
  border: 2px solid #c7c7c7;
}

.addRuleGroupButton.selected {
  background-color: #00dee6;
  border: 2px solid #b7b7b7;
}

.configEntryLine {
  height: 40px;
}
</style>
